module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Install the wepipe app and use it in full screen.","button":"Install now!"},"pt-BR":{"title":"Instale o app da wepipe e utilize em tela cheia.","button":"Instalar agora!"}}')
  delete Component.options._Ctor
}
